const items = [
  'Architecture',
  'Interior Design',
  'Construction',
  'Engineering',
  '3D Visualization',
  'Project Management',
  'Renovation',
  'Landscape Design',
];

export default function Marquee() {
  const track = [...items, ...items];

  return (
    <div style={{ background: '#0f9d94', padding: '13px 0', overflow: 'hidden' }}>
      <div
        style={{
          display: 'flex',
          width: 'max-content',
          animation: 'marqueeScroll 28s linear infinite',
        }}
      >
        {track.map((item, i) => (
          <span key={i} style={{ display: 'inline-flex', alignItems: 'center' }}>
            <span
              style={{
                fontSize: '10px',
                letterSpacing: '4px',
                textTransform: 'uppercase',
                color: '#071414',
                fontWeight: 600,
                padding: '0 36px',
                whiteSpace: 'nowrap',
                fontFamily: "'Cormorant Garamond', serif",
              }}
            >
              {item}
            </span>
            <span style={{ color: '#0a6f69', fontSize: '8px' }}>◆</span>
          </span>
        ))}
      </div>
    </div>
  );
}
